export default __webpack_public_path__ + "static/media/img11.3aba29bb.png";